import { ArrowLeft, ArrowRight, ChevronRight, ChevronUp } from "lucide-react";
import type { IconProps } from "~/design-system/types";

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 1"
        d="M19 8.5C19 8.5 14.856 15.5 12 15.5C9.145 15.5 5 8.5 5 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronUpIcon(props: IconProps) {
  return <ChevronUp {...props} />;
}

export function ChevronRightIcon(props: IconProps) {
  return <ChevronRight {...props} />;
}

export function ArrowRightIcon(props: IconProps) {
  return <ArrowRight {...props} />;
}

export function ArrowLeftIcon(props: IconProps) {
  return <ArrowLeft {...props} />;
}
